var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appeal-list-container"},[_c('area-appeal-list-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }